; (() => {
	if (customElements.get('mr-matches-value')) {
		return;
	}

	function isElementWithValue( x) {
		if ( !x ) {
			return false;
		}

		const y = x;

		return y.id !== undefined && y.value !== undefined && ( typeof y.value.toString === 'function' );
	}

	class MrMatchesValue extends HTMLElement {
		#matchQuery = null;

		static get observedAttributes() {
			return [
				'disabled',
				'for',
				'data-expect',
				'data-expect-flags',
			];
		}

		// Event Handlers
		#changeHandler = ( e ) => {
			if ( this.disabled ) {
				return;
			}

			const target = e.target;
			if ( !isElementWithValue( target ) ) {
				return;
			}

			if ( target.id !== this.getAttribute( 'for' ) ) {
				return;
			}

			this.testMatches();
		};

		// Life cycle
		connectedCallback() {
			this._addEventListeners();

			requestAnimationFrame( () => {
				this.setMatchQuery();
				this.testMatches();
			} );

			setTimeout( () => {
				this.setMatchQuery();
				this.testMatches();
			}, 100 );
		}

		disconnectedCallback() {
			this._removeEventListeners();
		}

		// Attributes
		setAttribute( attr, value ) {
			if ( this.disabled ) {
				return;
			}

			super.setAttribute( attr, value );
		}

		removeAttribute( attr ) {
			if ( this.disabled && 'disabled' !== attr ) {
				return;
			}

			super.removeAttribute( attr );
		}

		get disabled() {
			return this.hasAttribute( 'disabled' );
		}

		set disabled( value ) {
			if ( value ) {
				this.setAttribute( 'disabled', '' );
			} else {
				this.removeAttribute( 'disabled' );
			}
		}

		attributeChangedCallback( attrName, oldVal, newVal ) {
			if ( 'disabled' === attrName ) {
				this._removeEventListeners();
				if ( null === newVal ) {
					this._addEventListeners();
				}

				return;
			}

			if ( 'for' === attrName ) {
				this._removeEventListeners();
				this._addEventListeners();

				return;
			}

			if (
				'data-expect' === attrName ||
				'data-expect-flags' === attrName
			) {
				this.setMatchQuery();
				this.testMatches();

				return;
			}
		}

		_addEventListeners() {
			this.forEl?.addEventListener( 'change', this.#changeHandler );
			document.addEventListener( 'change', this.#changeHandler );
		}

		_removeEventListeners() {
			this.forEl?.removeEventListener( 'change', this.#changeHandler );
			document.removeEventListener( 'change', this.#changeHandler );
		}

		get forEl() {
			const forID = this.getAttribute( 'for' );
			if ( !forID ) {
				return null;
			}

			const el = document.getElementById( forID );
			if ( !el ) {
				return null;
			}
			if ( !isElementWithValue( el ) ) {
				return null;
			}

			return el;
		}

		setMatchQuery() {
			if ( !this.hasAttribute( 'data-expect' ) ) {
				this.#matchQuery = null;

				return;
			}

			const expect = this.getAttribute( 'data-expect' ) ?? '82cee87f-9739-4f31-91b5-bea2c03d2993'; // something unique that will never match
			const flags = this.getAttribute( 'data-expect-flags' ) ?? '';

			this.#matchQuery = new RegExp( expect, flags );
		}

		testMatches() {
			if ( !this.#matchQuery ) {
				this.removeAttribute( 'data-matches' );

				return;
			}

			const actual = this.forEl?.value.toString();

			if ( typeof actual !== 'string' ) {
				this.removeAttribute( 'data-matches' );

				return;
			}

			if ( !this.#matchQuery.test( actual ) ) {
				this.removeAttribute( 'data-matches' );

				return;
			}

			this.setAttribute( 'data-matches', '' );
		}
	}

	customElements.define('mr-matches-value', MrMatchesValue);
})();
